<template>
  <container id="registerPage" >
            <div id="register">
                <h3 class="text-center pt-5 text-info">Register Form</h3>
                <div class="container">
                    <div id="register-row" class="row justify-content-center align-items-center">
                        <div id="register-column" class="col-md-6">
                            <div id="register-box" class="col-md-12">
                                <form id="register-form" class="form" v-on:submit.prevent="registerPost">
                                    <h3 class="text-center text-info">Register</h3>
                                    <div class="form-group">
                                        <label for="username" class="text-info">Username:</label><br>
                                        <input type="text" name="username" id="username" class="form-control" v-model="registerName">
                                    </div>
                                    <div class="form-group">
                                        <label for="email" class="text-info">Email:</label><br>
                                        <input type="text" name="email" id="email" class="form-control" v-model="registerEmail">
                                    </div>
                                    <div class="form-group">
                                        <label for="password" class="text-info">Password:</label><br>
                                        <input type="password" name="password" id="password" class="form-control" v-model="registerPassword">
                                    </div>
                                    <div class="form-group">
                                        <label for="rePassword" class="text-info">Confirm Password:</label><br>
                                        <input type="password" name="rePassword" id="rePassword" class="form-control" v-model="registerRePassword">
                                    </div>
                                    <div class="form-group">
                                        <input type="submit" name="submit" class="btn btn-info btn-md" value="submit">
                                        <a class="text-info" v-on:click="login()">Login Here</a>
                                    </div>

                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </container>

</template>

<script>
export default {
    name:'Register Page',
    data(){
        return {
            registerEmail:'',
            registerPassword:'',
            registerRePassword:'',
            registerName:'',
        }
    },
    methods:{
        login(){
            this.$emit('login')
        },
        registerPost(){
            let payload={
                name:this.registerName,
                email:this.registerEmail,
                password:this.registerPassword,
                rePassword:this.registerRePassword,
            }
            this.$emit('registerPost',payload);
            this.registerEmail='';
            this.registerPassword='';
            this.registerRePassword='';
            this.registerName='';

        }
    }

}
</script>

<style>

</style>